<div role="group" [class]="model.cssClasses.root">
  <sv-button-group-item *ngFor="let item of model.visibleChoices; index as index" [question]="model" [item]="item" [index]="index" ></sv-button-group-item>
</div>
